export class EmailEvents extends HTMLElement
{
    options =  {
        CONDITION_OPERATORS: {
            1: '=',
            2: '!=',
            3: '>',
            4: '<',
            5: 'like'
        }

    };

    constructor ()
    {
        super();
    }
    connectedCallback()
    {
        this.init();
    }
    /*
     * Vetology.LionManager.init
     *
     * @description	Initializes the Vetology.LionManager
     *
     * @return NULL
     *
     */
    init()
    {
        var o = this;
        this.addEventHandlers();
    }

    /*
     * Vetology.Vetology.addEventHandlers
     *
     * @description	Placeholder for a method
     *
     * @return NULL
     *
     */
    initConditionSelector() {
        const self = this;
        let triggerParameters = window.triggerParameters;
        if (triggerParameters) {
            triggerParameters = JSON.parse(triggerParameters);
            if (typeof triggerParameters == "object") {
                $.each(triggerParameters, function(idx, param) {
                    const $tr = self.buildInitialRow(param);
                    $("tbody", "div.json_manager").append($tr);
                });
            }
        }
    }

    addEventHandlers()
    {
        var o = this;

        this.addEventListener('click', this.handleClick.bind(this));


        $("body").on('classChange', 'div.json_manager', function(e) {
            if ($(this).hasClass('needs-init')) {
                o.initConditionSelector();
                $(this).removeClass('needs-init');

                // now that the json table has been initialized, set the event handlers for it
                o.addPostInitEventHandlers();
            }
        });

        this.onAddRowBtnClick = this.onAddRowBtnClick.bind(this);
        document.body.addEventListener('click', event => {
            if (event.target.closest('div.json_manager') && event.target.classList.contains('add_row') || event.target.parentNode.classList.contains('add_row')) {
                this.onAddRowBtnClick(event);
            }
        });



    }

    handleClick(event)
    {
        if (event.target.id == "test-conditions-btn") {
            event.stopPropagation();
            event.preventDefault();

            this.handleTestConditionsClick(event);
        }
    }

    addPostInitEventHandlers() {
        const self = this;

        // need to manually change value for checkbox input
        $("html").on("click", ".json_table .input_value[type=checkbox]", function(e) {
            $(e.target).val(this.checked ? 1 : 0);
        });

        $("html").on('change', "select.input_column", function(e) {
            e.stopImmediatePropagation();
            var colSelector = $(e.target);
            var newOption = colSelector.children(":selected");
            var idx = colSelector.data('index');
            var row = colSelector.closest('tr');
            var curValueCtrl = row.find(".input_value[data-index=" + idx + "]");
            var curCtrlType = curValueCtrl.data("ctrltype");
            var newCtrlType = newOption.data("ctrltype");
            self.setCtrlType(row, idx, "");
            if (idx == 1) {
                // check for select2 remnants
                var spanSel2 = $(".input_value[data-index=2]").next('span.select2');
                if (spanSel2.length) {
                    spanSel2.remove();
                }
            }
        });

        // include related conditions, and multi-select options in post data
        $("html").on("jsonTableUpdated", ".current_value", function(e, settings) {
            settings = JSON.parse(settings);
            var newVal = [];
            var rows = $("tbody tr.objectFinder_block", ".json_table");
            $.each(rows, function(i, row){
                row = $(row);
                if(row.hasClass("danger")){
                    return true;
                }
                var n = {};
                $.each(settings, function(a, s){
                    var inputs = row.find('.input_' + s.id);
                    if (inputs.length > 1 && parseInt(row.find(".input_object[data-index=2]").val()) > 0) {
                        // primary + related
                        n[s.id] = $(inputs[0]).val();
                        n[s.id + "2"] = $(inputs[1]).val();
                    } else {
                        n[s.id] = inputs.val();
                    }

                });
                newVal.push(n);
            });
            newVal = JSON.stringify(newVal);
            $(".current_value", ".json_table").val(newVal);
        });

        const conditionalObserver = new MutationObserver(function(mutationsList, observer) {
            for (let mutation of mutationsList) {
                let test = mutation;
                if (typeof mutation.addedNodes == "object") {
                    let $row = $(mutation.addedNodes[0]);
                    let $operatorSel = $("select.input_operator", $row);
                    self.populateOperationOptions($operatorSel);
                }
            }
        });

        conditionalObserver.observe($(".json_table tbody").get(0), {
            attributes: false,
            childList: true,
            subtree: false
        });

    }

    buildInitialRow(param)
    {
        var o = this;
        const hasSecondaryCondition = (typeof param.object2 !== 'undefined');

        var $tdSortHandle = $("<td><span class='vetology-move ui-sortable-handle'/></td>");
        let $tdObject = o.buildInitialObjectColumn(param);
        let $tdColumn = o.buildInitialColumnColumn(param, $tdObject);
        let $tdOperator = o.buildInitialOperatorColumn(param);
        let $tdValue = o.buildInitialValueColumn(param);
        let $tdTrash = $("<td><a class='vetology_pd remove_row' href='#'><span class='vetology-delete'></span></a>");

        var $tr = $("<tr class='objectFinder_block'>");
        $tr.append($tdSortHandle)
            .append($tdObject)
            .append($tdColumn)
            .append($tdOperator)
            .append($tdValue)
            .append($tdTrash);

        o.setCtrlType($tr, 1, param.value);
        if (hasSecondaryCondition) {
            o.setCtrlType($tr, 2, param.value2);
        }

        return $tr;
    }

    buildInitialObjectColumn(param) {
        const hasSecondaryCondition = (typeof param.object2 !== 'undefined');

        var $tdObject = $("<td><select class='form-control input_object objectFinder' data-index='1'/></td>");
        this.populateObjectOptions($("select", $tdObject), param.object);
        let $select2 = $("<select class='form-control input_object objectFinder' data-index='2'/>");
        if (hasSecondaryCondition) {
            this.populateObjectOptions($select2, param.object2);
        } else {
            this.populateObjectOptions($select2, 0);
        }
        $tdObject.append($select2);

        return $tdObject;
    }

    buildInitialColumnColumn(param, $tdObject)
    {
        const hasSecondaryCondition = (typeof param.object2 !== 'undefined');

        let $tdColumn = $("<td><select class='form-control input_column objectFinderColumn' data-index='1'/></td>");
        this.populateColumnOptions($("select", $tdColumn), $("select[data-index=1] option:selected", $tdObject).data('columns'), param.column);

        let $select2 = $("<select class='form-control input_column objectFinderColumn' data-index=2 />");
        if (hasSecondaryCondition) {
            this.populateColumnOptions($select2, $("select[data-index=2] option:selected", $tdObject).data('columns'), param.column2);
        }
        $tdColumn.append($select2);

        return $tdColumn;
    }

    buildInitialOperatorColumn(param)
    {
        const hasSecondaryCondition = (typeof param.object2 !== 'undefined');

        let $tdOperator = $("<td><select class='form-control input_operator' data-index='1'/></td>");
        this.populateOperationOptions($("select", $tdOperator), param.operator);

        let $select2 = $("<select class='form-control input_operator' data-index=2 />");
        this.populateOperationOptions($select2, param.operator2);

        $tdOperator.append($select2);

        return $tdOperator;
    }

    buildInitialValueColumn(param)
    {
        const hasSecondaryCondition = (typeof param.object2 !== 'undefined');

        let $tdValue = $("<td><input class='form-control input_value' type='text' data-ctrltype='1' value='" + param.value + "' data-index='1'/></td>");

        let $input2 = $("<input class='form-control input_value' type='text' data-ctrltype='1' value='' data-index=2 />");
        if (hasSecondaryCondition) {
            $input2.val(param.value2);
        }
        $tdValue.append($input2);

        return $tdValue;
    }

    setCtrlType(row, idx, value)
    {
        // get control type from column option
        var newCtrlType = row.find("select.input_column[data-index=" + idx + "] option:selected").data("ctrltype");
        // don't set operator if we're initializing the row (value will be set)
        if (value == ""  || newCtrlType == 4 || newCtrlType == 5 || newCtrlType == 6) {
            this.setOperator(newCtrlType, row, idx);
        }
        if (idx == 1) {
            var curValueCtrl = row.find(".input_value[data-index!=2]");
            curValueCtrl.attr("data-index=1");
        } else {
            var curValueCtrl = row.find(".input_value[data-index=2]");
        }
        var curValueCtrlType = curValueCtrl.data('ctrltype') || 1;

        var newCtrl = $("[data-ctrltype=" + newCtrlType + "]", ".ctrl-holder").clone();
        newCtrl.attr('data-index', idx);
        newCtrl.removeClass("hidden");
        if (curValueCtrlType == 5 && typeof curValueCtrl.select2 !== "undefined" ) {
            curValueCtrl.val(null).trigger('change');
            curValueCtrl.select2('destroy');
            curValueCtrl.next(".select2").remove();
        }
        if (curValueCtrl.length) {
            curValueCtrl.replaceWith(newCtrl);
        } else {
            $("td:eq(4)", row).append(newCtrl);
        }
        switch(newCtrlType) {
            case 1:
                newCtrl.val(value);
                break;
            case 2:
            case 6:
                var options = this.getSelectionOptions(row, idx);
                newCtrl.append(options);
                if (value) {
                    newCtrl.val(value);
                }
                break;
            case 3:
                var d = new Date(value);
                newCtrl.val(d != "Invalid Date" ? d.toISOString().split('T')[0] : "");
                break;
            case 4:
                if (parseInt(value) > 0) {
                    newCtrl.attr('checked', 'checked');
                    newCtrl.val(1);
                } else {
                    newCtrl.removeAttr('checked');
                    newCtrl.val(0);
                }
                break;
            case 5:
                var options = this.getSelectionOptions(row, idx);
                newCtrl.append(options);
                newCtrl.closest("td").css("max-width", "400px");
                newCtrl.val(value);
                newCtrl.select2();
        }

    }

    setOperator(ctrlType, tr, idx)
    {
        var operatorSel = $("select.input_operator[data-index=" + idx + "]", tr);
        operatorSel.val(0);
        operatorSel.children('option').filter(function(i, el) {
            return $(el).attr('value') > 100;
        }).remove();
        operatorSel.removeAttr('disabled').children().removeAttr('disabled');
        $("option:eq(0)", operatorSel).prop('selected', true).prop('disabled', true);
        switch (ctrlType) {
            case 1: // input
                break;
            case 2: // regular select
                operatorSel.children('[value=5]').prop('disabled', true);
                break;
            case 3: // date
                $('option[value=2]', operatorSel).attr('disabled', true);
                $('option[value=5]', operatorSel).attr('disabled', true);
                break;
            case 4: // checkbox
                $("<option value='101' selected>Check/Uncheck to set option</option>").appendTo(operatorSel);
                operatorSel.attr('disabled', true);
                break;
            case 5: // multi sel
                $("<option value='102' selected>Select options to the right</option>").appendTo(operatorSel);
                operatorSel.attr('disabled', true);
                break;
        }
    }

    getSelectionOptions(tr, idx)
    {
        var objSelector = tr.find(".input_object[data-index=" + idx + "]");
        var colSelector = tr.find(".input_column[data-index=" + idx + "]");
        switch (parseInt(objSelector.val())) {
            case 1: // cases
                if (colSelector.val() == "ReviewTypeID") {
                    var options = window.reviewTypeOptions;
                    return options;
                } else if (colSelector.val() == "CaseFlagID") {
                    var options = window.caseFlagOptions;
                    return options;
                }

                break;
            case 5: // clinic
                if (colSelector.val() == 'marketing_campaigns') {
                    var options = window.marketingCampaignOptions;
                    return options;
                }
                break;
            case 11: // patient
                const colSelectorVal = colSelector.val();
                if (colSelectorVal == 'Age') {
                    return this.getAgeOptions();
                } else if (colSelectorVal == 'Breed') {
                    var options = window.breedOptions;
                    return options;
                } else if (colSelectorVal == 'Sex') { 
                    var options = this.getSexOptions();
                    return options;
                } else if (colSelectorVal == 'Species') {
                    var options = window.speciesOptions;
                    return options;
            }

                break;
        }
    }

    getAgeOptions()
    {
        var options = "<option value=\"-1\" selected disabled>Select patients age</option>";
        for (var i = 1; i <= 25; ++i) {
            options += "<option value=\"" + i + "\">" + i + " years</option>";
        }
        return options;
    }

    getSexOptions()
    {
        var options = "<option value=\"-1\" selected disabled>Select Patients sex</options>";
        options += "<option value=\"M\">Male</option>";
        options += "<option value=\"F\">Female</option>";
        return options;
    }

    populateObjectOptions($selector, selected)
    {
        var options = window.objectOptions;

        if (typeof options == "string") {
            options = JSON.parse(options);
            if (typeof options == "object") {
                if (selected == 0 || $selector.data('index') == 2) {
                    $selector.append($("<option value=0 selected>Select an option to add to the condition above (optional)</option>"));
                }
                $.each(options, function(idx, option) {
                    if ($selector.data('index') == 2 || idx == 1) {
                        $selector.append($("<option value='" + idx + "'" + (idx == selected ? " selected" : "") + ">" + option['name'] + "</option>").data('columns', JSON.stringify(option['columns'])));
                    }
                });
            }
        }
    }

    populateColumnOptions($selector, columns, selected)
    {
        const columnsArr = JSON.parse(columns);
        let options = "";
        let idx = 0;
        $.each(columnsArr, function(colName, ctrlType) {
            let $option = $("<option value='" + colName + "' data-ctrltype=" + ctrlType + ">" + colName + "</option>");
            if (colName == selected) {
                $option.prop('selected', true);
            }
            $selector.append($option);
            ++idx;
        });
    }

    populateOperationOptions($selector, selected)
    {
        $selector.empty();
        var options = this.options.CONDITION_OPERATORS;
        if (typeof selected == "undefined") {
            $selector.append($("<option value=0 selected disabled></option>"));
        }
        $.each(options, function(idx, el) {
            let $opt = $("<option value='" + idx + "'>" +  el + "</option>");
            if (idx == selected) {
                $opt.prop('selected', true);
            }
            $selector.append($opt);
        });
    }

    handleTestConditionsClick(event)
    {
        const form = event.target.closest('form.editForm');
        const sendToSelector = form.querySelector('select[name="send_to[]"]');
        if (sendToSelector.value.length == 0) {
            toastr.warning('Please select at least one email recipient');
            return false;
        }
        let conditionalData = [];
        let rows = form.querySelectorAll(' .json_manager tr.objectFinder_block');
        let errors = [];
        rows.forEach((row, idx) => {
            if (!row.classList.contains('danger')) {
                let rowConditions = {};
                const objectElem = row.querySelector('select.input_object[data-index="1"] option:checked');
                const columnElem = row.querySelector('select.input_column[data-index="1"] option:checked');
                const operatorElem = row.querySelector('select.input_operator[data-index="1"] option:checked');
                rowConditions.object = objectElem.value;
                rowConditions.column = columnElem.value;
                rowConditions.operator = operatorElem.value;
                rowConditions.value = this.getConditionValue(row,rowConditions, 1);
                this.validateCondition(rowConditions, errors);

                let secondaryConditional = row.querySelector('select.input_object[data-index="2"] option:checked');
                if (secondaryConditional.value > 0) {
                    rowConditions.object2 = secondaryConditional.value;
                    const columnElem2 = row.querySelector('select.input_column[data-index="2"] option:checked');
                    const operatorElem2 = row.querySelector('select.input_operator[data-index="2"] option:checked');
                    const valueElem2 = row.querySelector('.input_value[data-index="2"]');
                    rowConditions.column2 = columnElem2.value;
                    rowConditions.operator2 = operatorElem2.value;
                    rowConditions.value2 = this.getConditionValue(row, rowConditions, 2);
                }
                conditionalData.push(rowConditions);
            }
        });

        if (errors.length > 0) {
            let errorString = ""
            errors.forEach(error => {
                errorString += error + "<br/>";
            });
            toastr.error(errorString);
            return;
        }

        const testOutputElem = form.querySelector('.test-output');
        testOutputElem.innerHTML = "<h4 class='text-center text-info'> Testing conditions...  Please wait... This may take a few seconds.</h4>";

        const emailEventElem = form.querySelector('input[name=spid]');
        const emailEventID = emailEventElem.value;

        const formData = new FormData();
        formData.append('eventID', emailEventID);
        formData.append('conditions', JSON.stringify(conditionalData));
        const queryStringParam = new URLSearchParams(formData);
        const queryString = queryStringParam.toString();

        fetch("/admin/email/events/test-email-event/" + emailEventID + "?" + queryString,
            {
                method: 'get',
                headers: {
                    accept: 'application/text'
                }
            }).then(response => {
                if (response.ok) {
                    toastr.success('Conditions tested successfully - see below for output');
                    response.text().then(data => {
                        const testOutputElem = form.querySelector('.test-output');
                        testOutputElem.innerHTML = data;
                    });
                } else {
                    toastr.error('Error while testing conditions.  Please report error');
                }
            });
    }
    validateCondition(condition, errors)
    {
        if (condition.operator != 102 && condition.value == '') {
            errors.push("Please specify a value for your rule(s)");
        }
    }

    getConditionValue(row, condition, idx)
    {
        const operator = (idx == 1? condition.operator : condition.operator2);

        let value = false;
        if (operator == 102) {
            const options = row.querySelectorAll('.input_value[data-index="1"] :checked');
            value = [];
            options.forEach(elem => {
                value.push(elem.value);
            });
        } else {
            const valueElem = row.querySelector('.input_value[data-index="' + idx + '"]');
            value = valueElem.value;
        }

        return value;
    }

    onAddRowBtnClick(event)
    {
        // find the last row, and remove all but Clinic Cases from the object dropdown
        const form = event.target.closest('form.editForm');
        const lastRow = form.querySelector('.json_manager tr.objectFinder_block:last-child');
        const objectElem = lastRow.querySelector('select.objectFinder[data-index="1"]');
        const options = objectElem.querySelectorAll('option:not([value="1"])');
        options.forEach(option => {
            option.remove();
        });
        const changeEvent = new Event('change', { bubbles: true });
        objectElem.dispatchEvent(changeEvent);
     }

}

customElements.define('email-events', EmailEvents);